import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import ICONS from '../../../../../../enums/icons';
import { Button } from '../../../../../ui/button';
import { ModalClose, ModalFooter } from '../../../../../ui/modal';
import PropTypes from 'prop-types';

const FooterClose = ({ isLoading }) => {
    return (
        <ModalFooter>
            {isLoading && <Spinner className='form-spinner' />}
            <ModalClose asChild>
                <Button
                    type='submit'
                    variant='primary'
                    entity={'button.close'}
                    icon={ICONS.CLOSE}
                    dataCy='modal-footer-close'
                />
            </ModalClose>
        </ModalFooter>
    );
};

FooterClose.propTypes = {
    isLoading: PropTypes.bool
};

export default FooterClose;